"use strict";

exports.__esModule = true;
exports.StripeChartTooltip = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _styledComponents = require("styled-components");
var _styles = require("./styles");
var _Utils = require("../../../Utils");
var _utils = require("./utils");
var _moment = _interopRequireDefault(require("moment"));
var _StripeChartTooltipDate = require("./StripeChartTooltipDate");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var arrayTooltipRender = function arrayTooltipRender(_ref) {
  var data = _ref.data,
    renderContent = _ref.renderContent,
    theme = _ref.theme,
    timezone = _ref.timezone,
    intervalBetweenEvents = _ref.intervalBetweenEvents;
  if (data.length < 1) return [];
  if (data[0].type !== "condition") return data.map(renderContent);
  data = (0, _utils.uniqueConditions)(data);
  //sorting data by type (fault, warning)
  var sortedDataByConditionLevel = data.sort(function (a, b) {
    return a.dimensions.condition_level.localeCompare(b.dimensions.condition_level);
  });
  var borderBottom = "1px solid " + theme.TooltipContentBorderBottomColor;
  var conditionLevelType = sortedDataByConditionLevel[0].dimensions.condition_level;
  var conditionLevelTypeChanged = false;
  var dictionary = sortedDataByConditionLevel.reduce(function (dict, doc, index) {
    var positions = dict[doc.dimensions.condition_level];
    conditionLevelTypeChanged = false;
    if (conditionLevelType !== doc.dimensions.condition_level) {
      conditionLevelType = doc.dimensions.condition_level;
      conditionLevelTypeChanged = true;
    }
    var text = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (index === 0 || conditionLevelTypeChanged || doc.interval.startMillis - data[index - 1].interval.startMillis - intervalBetweenEvents.timestamp > 0) && /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        borderBottom: borderBottom,
        marginBottom: "5px"
      }
    }, "" + (0, _moment["default"])(doc.timestamp).tz(timezone).format(intervalBetweenEvents.timeFormat)), /*#__PURE__*/_react["default"].createElement(_styles.TooltipLine, {
      key: "Tooltip." + doc.dimensions.condition_level + "." + doc.entity.native_code + "." + doc.dimensions.condition_text
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        wordWrap: "break-word",
        display: "inline-block",
        width: "90px"
      }
    }, "" + doc.entity.native_code), /*#__PURE__*/_react["default"].createElement(_styles.TooltipConditionText, {
      "data-testid": "StripeChartTooltipConditionText"
    }, doc.dimensions.condition_text), /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        marginRight: "10px"
      }
    }, "" + (0, _moment["default"])(doc.timestamp).tz(timezone).format("HH:mm:ss"))));
    if (positions) {
      positions.push(text);
    } else {
      dict[doc.dimensions.condition_level.toLowerCase()] = [text];
    }
    return dict;
  }, {
    fault: undefined,
    warning: undefined
  });
  return Object.keys(dictionary).map(function (key) {
    return dictionary[key] ? /*#__PURE__*/_react["default"].createElement(_styles.StripeChartCommentGrid, null, /*#__PURE__*/_react["default"].createElement(_styles.TooltipConditionType, {
      key: "Tooltip." + key,
      style: {
        color: "" + theme.TooltipContentColor
      }
    }, (0, _Utils.capitalizeWords)([key])), /*#__PURE__*/_react["default"].createElement(_styles.TooltipContent, null, dictionary[key])) : undefined;
  });
};
var StripeChartTooltip = exports.StripeChartTooltip = (0, _styledComponents.withTheme)(function (props) {
  var isActive = props.isActive,
    x = props.x,
    renderContent = props.renderContent,
    data = props.data,
    timeInMs = props.timeInMs,
    theme = props.theme,
    position = props.position,
    height = props.height,
    timezone = props.timezone,
    intervalBetweenEvents = props.intervalBetweenEvents;
  if (!isActive || !data || (data == null ? void 0 : data.length) < 1) {
    return null;
  }
  var content = Array.isArray(data) ? arrayTooltipRender({
    data: data,
    renderContent: renderContent,
    theme: theme,
    timezone: timezone,
    intervalBetweenEvents: intervalBetweenEvents
  }) : renderContent(data);
  var shouldRenderStripeChartTooltipDate = !Array.isArray(data) || data.length < 1 && data[0].type !== "condition";
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "StripeChartTooltip",
    style: {
      position: "absolute",
      display: "flex",
      flexDirection: "row",
      left: (x !== null ? x : 0) + "px",
      zIndex: "3",
      bottom: "3px",
      borderLeft: "1px solid " + theme.ToolTipHandleColor,
      height: height + "px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    usePortal: true,
    popoverClassName: ["chart-tooltip"],
    isOpen: isActive,
    position: position,
    content: /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: "max-content",
        color: theme.TooltipContentColor
      },
      "data-testid": "StripeChartTooltipContent"
    }, shouldRenderStripeChartTooltipDate && /*#__PURE__*/_react["default"].createElement(_StripeChartTooltipDate.StripeChartTooltipDate, {
      timeInMs: timeInMs,
      style: {
        textAlign: "center",
        marginBottom: content && content.length !== 0 ? "5px" : 0,
        fontSize: theme.fontSizeXS,
        color: theme.TooltipContentColor
      },
      contentPresent: content && content.length !== 0
    }), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        borderBottom: "none",
        color: "" + theme.TooltipContentColor,
        marginBottom: "5px"
      }
    }, content))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "5px",
      textAlign: "center"
    }
  })));
});